export const state = () => ({
  uid: '1da7a2b6-e69a-4361-864f-d43586134e6a',
  firstName: 'Laurynas',
  lastName: 'Antanavicius',
  email: 'laurisant@gmail.com',
  phoneNumber: '+37062268868',
  defaultPaymentMethod: 'testcard123',
});
